// extracted by mini-css-extract-plugin
export default {"recos":"e4-z","productCardOverride":"f4-z","rowHasBadge":"g4-z"};